import { useCallback, useState } from 'react';

type Copied = string | null;

type CopyFn = (text: string) => Promise<boolean>;

export const useCopyToClipboard = (): { copied: Copied; copy: CopyFn } => {
  const [copied, setCopied] = useState<Copied>(null);

  const copy: CopyFn = useCallback(async text => {
    if (!navigator?.clipboard) {
      return false;
    }

    try {
      await navigator.clipboard.writeText(text);
      setCopied(text);
      return true;
    } catch (_error) {
      setCopied(null);
      return false;
    }
  }, []);

  return { copied, copy };
};
